import CityPageTemplate from "../city-template/CityPageTemplate";
import { yakimaConfig } from "./data";

export default function YakimaPage() {
  return <CityPageTemplate config={yakimaConfig} />;
}